import type { CardDef } from '../types.js';

/** Book 1 starter pool (~22 cards + scars added at runtime). */
export const CARD_POOL: CardDef[] = [
  {
    id: 'twist_twin',
    name: 'It Was a Twin',
    type: 'twist',
    cost: 1,
    beatTypes: ['character'],
    description: 'Reveal a secret sibling. The narrator hates this one.',
  },
  {
    id: 'twist_actually_door',
    name: 'Actually, a Door',
    type: 'twist',
    cost: 1,
    beatTypes: ['place', 'object'],
    description: 'That wall? Door now. Always was, allegedly.',
  },
  {
    id: 'twist_wrong_hero',
    name: 'Wrong Hero',
    type: 'twist',
    cost: 2,
    beatTypes: ['character', 'event'],
    description: 'Swap who the story thinks is brave.',
  },
  {
    id: 'rule_rewind_line',
    name: 'Read That Again',
    type: 'rule_breaker',
    cost: 2,
    beatTypes: ['mood', 'event'],
    description: 'Force the narrator to repeat the last beat, softer.',
  },
  {
    id: 'rule_skip_intent',
    name: 'Cut the Foreshadowing',
    type: 'rule_breaker',
    cost: 2,
    beatTypes: ['event', 'mood'],
    description: 'Cancel the Narrator intent for this scene.',
  },
  {
    id: 'rule_lie_mode',
    name: 'Narrator May Lie',
    type: 'rule_breaker',
    cost: 1,
    beatTypes: ['mood'],
    description: 'Next narrator line contradicts itself once, on purpose.',
  },
  {
    id: 'chaos_gravity_off',
    name: 'Gravity Turns Off',
    type: 'chaos',
    cost: 2,
    beatTypes: ['place', 'object', 'event'],
    description: 'Everything drifts. The story pretends this is fine.',
  },
  {
    id: 'chaos_sudden_festival',
    name: 'Sudden Festival',
    type: 'chaos',
    cost: 1,
    beatTypes: ['place', 'mood'],
    description: 'Confetti, drums, inappropriate joy.',
  },
  {
    id: 'chaos_prophecy_wrong',
    name: 'Prophecy Typo',
    type: 'chaos',
    cost: 1,
    beatTypes: ['event', 'mood'],
    description: 'The ancient text was misread. Hilariously.',
  },
  {
    id: 'counter_nope',
    name: 'Nope',
    type: 'counter',
    cost: 0,
    beatTypes: ['character', 'place', 'object', 'event', 'mood'],
    description: 'Cancel the Narrator intent instead of your card.',
  },
  {
    id: 'counter_not_yet',
    name: 'Not Yet',
    type: 'counter',
    cost: 1,
    beatTypes: ['event'],
    description: 'Delay dread from the intent by one beat.',
  },
  {
    id: 'keep_lucky_charm',
    name: 'Lucky Charm',
    type: 'keepsake',
    cost: 1,
    beatTypes: ['character', 'object'],
    description: 'Stick a charm on a character. It will matter later.',
  },
  {
    id: 'keep_curse_mark',
    name: 'Curse Mark',
    type: 'keepsake',
    cost: 1,
    beatTypes: ['character'],
    description: 'A mark that glows when the narrator lies.',
  },
  {
    id: 'twist_frog_curse',
    name: 'Frog Curse',
    type: 'twist',
    cost: 2,
    beatTypes: ['character'],
    description: 'Royalty, amphibians, consequences.',
    upgradeId: 'twist_frog_curse_foil',
  },
  {
    id: 'twist_frog_curse_foil',
    name: 'Frog Curse (Foil)',
    type: 'twist',
    cost: 1,
    beatTypes: ['character'],
    description: 'Upgraded. The pond remembers.',
    rarity: 'foil',
  },
  {
    id: 'twist_secret_tunnel',
    name: 'Secret Tunnel',
    type: 'twist',
    cost: 1,
    beatTypes: ['place'],
    description: 'Of course there was a tunnel. Obviously.',
  },
  {
    id: 'chaos_storm_indoors',
    name: 'Storm Indoors',
    type: 'chaos',
    cost: 2,
    beatTypes: ['place', 'mood'],
    description: 'Weather refuses to stay outside.',
  },
  {
    id: 'rule_page_stain',
    name: 'Ink Stain',
    type: 'rule_breaker',
    cost: 1,
    beatTypes: ['object', 'mood'],
    description: 'Smudge a word. The story rewrites around it.',
  },
  {
    id: 'keep_story_debt',
    name: 'Story Debt',
    type: 'keepsake',
    cost: 0,
    beatTypes: ['character'],
    description: 'Someone owes the plot a favor.',
  },
  {
    id: 'twist_macguffin_fake',
    name: 'Fake MacGuffin',
    type: 'twist',
    cost: 1,
    beatTypes: ['object', 'event'],
    description: 'The treasure was decoy. The narrator looks tired.',
  },
  {
    id: 'chaos_time_skip',
    name: 'Time Skip',
    type: 'chaos',
    cost: 2,
    beatTypes: ['event'],
    description: 'Jump ahead. Nobody gets to explain.',
  },
  {
    id: 'twist_helpful_stranger',
    name: 'Too Helpful Stranger',
    type: 'twist',
    cost: 1,
    beatTypes: ['character'],
    description: 'Someone helpful arrives. Suspiciously so.',
  },
  {
    id: 'twist_oath_skipped',
    name: 'Oath? Skipped.',
    type: 'twist',
    cost: 1,
    beatTypes: ['event', 'mood'],
    description: 'The solemn vow becomes optional paperwork.',
  },
  {
    id: 'rule_chapter_title',
    name: 'Wrong Chapter Title',
    type: 'rule_breaker',
    cost: 1,
    beatTypes: ['event', 'mood'],
    description: 'Rename the chapter while the narrator is reading it.',
  },
  {
    id: 'chaos_ink_tide',
    name: 'Ink Tide',
    type: 'chaos',
    cost: 2,
    beatTypes: ['place', 'event'],
    description: 'Raise the flood. Everyone paddles.',
  },
  {
    id: 'keep_margin_ribbon',
    name: 'Margin Ribbon',
    type: 'keepsake',
    cost: 1,
    beatTypes: ['character', 'object'],
    description: 'Tie a favor to Sir Margin or anyone edge-adjacent.',
  },
  {
    id: 'twist_jury_favor',
    name: 'Jury Favor',
    type: 'twist',
    cost: 2,
    beatTypes: ['character'],
    description: 'The jury likes you now. Temporarily.',
  },
  {
    id: 'rule_footnote',
    name: 'Hostile Footnote',
    type: 'rule_breaker',
    cost: 1,
    beatTypes: ['mood', 'object'],
    description: 'A footnote argues back in public.',
  },
  {
    id: 'chaos_wax_melt',
    name: 'Wax Melt',
    type: 'chaos',
    cost: 2,
    beatTypes: ['place', 'object'],
    description: 'Candles become puddles. Gravity stays polite.',
  },
  {
    id: 'counter_objection',
    name: 'Objection!',
    type: 'counter',
    cost: 1,
    beatTypes: ['event'],
    description: 'Legal drama interrupts the Narrator intent.',
  },
  {
    id: 'keep_tribunal_favor',
    name: 'Tribunal Favor',
    type: 'keepsake',
    cost: 1,
    beatTypes: ['character'],
    description: 'The court owes you one small ruling.',
  },
  {
    id: 'twist_verdict_flip',
    name: 'Verdict Flip',
    type: 'twist',
    cost: 2,
    beatTypes: ['event'],
    description: 'Guilty becomes party hats. Do not ask how.',
  },
  {
    id: 'chaos_sidebar_storm',
    name: 'Sidebar Storm',
    type: 'chaos',
    cost: 1,
    beatTypes: ['mood', 'event'],
    description: 'Weather in the margins only.',
  },
  {
    id: 'rule_cross_out',
    name: 'Cross Out',
    type: 'rule_breaker',
    cost: 1,
    beatTypes: ['object', 'event'],
    description: 'Strike a word. The scene rebuilds around the gap.',
  },
  {
    id: 'twist_scar_witness',
    name: 'Scar Witness',
    type: 'twist',
    cost: 1,
    beatTypes: ['character', 'object'],
    description: 'A Scar card testifies. The narrator sweats.',
  },
  {
    id: 'keep_crown_wick',
    name: 'Saved Wick',
    type: 'keepsake',
    cost: 1,
    beatTypes: ['object'],
    description: 'Bank a flame on the Crown for later.',
  },
];

export const STARTER_DECK_IDS: string[] = [
  'twist_twin',
  'twist_actually_door',
  'counter_nope',
  'keep_lucky_charm',
  'chaos_sudden_festival',
  'rule_page_stain',
  'twist_secret_tunnel',
  'twist_helpful_stranger',
  'chaos_prophecy_wrong',
  'keep_story_debt',
  'twist_macguffin_fake',
  'counter_not_yet',
];

export const SCAR_CARDS: CardDef[] = [
  {
    id: 'scar_narrator_grudge',
    name: 'Narrator Grudge',
    type: 'rule_breaker',
    cost: 0,
    beatTypes: ['mood'],
    description: 'From a past run. The voice remembers you.',
    isScar: true,
    rarity: 'ink',
  },
  {
    id: 'scar_unfinished_ending',
    name: 'Unfinished Page',
    type: 'chaos',
    cost: 1,
    beatTypes: ['event'],
    description: 'A ending you never reached tears the margin.',
    isScar: true,
  },
  {
    id: 'scar_dread_echo',
    name: 'Dread Echo',
    type: 'keepsake',
    cost: 0,
    beatTypes: ['mood'],
    description: 'Dread from before still hums in the text.',
    isScar: true,
  },
];

export function getCardById(id: string, extra: CardDef[] = []): CardDef | undefined {
  return [...CARD_POOL, ...SCAR_CARDS, ...extra].find((c) => c.id === id);
}

export function allCardDefs(extra: CardDef[] = []): CardDef[] {
  const map = new Map<string, CardDef>();
  for (const c of [...CARD_POOL, ...SCAR_CARDS, ...extra]) {
    map.set(c.id, c);
  }
  return [...map.values()];
}
